import React, { Component } from 'react'
import { List } from 'immutable'
import { FieldArray } from 'redux-form/immutable'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import PeerInviteInputs from './PeerInviteInputs'
import Button from 'app/components/ButtonDefault'
import './style.scss'

const bc = 'peer-invite-form'

class PeerInviteForm extends Component {
  static propTypes = {
    proTracksList: PropTypes.object,
    location: PropTypes.object,
    fetchIdRequest: PropTypes.func,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
    onRequestClose: PropTypes.func,
  }

  usersNotEmpty = (immutableUsers = List([])) => {
    const users = immutableUsers.toJS()
    return !users.filter(user => user.email).length
  }

  render() {
    const { t, handleSubmit, submitting, onRequestClose, users, invalid } = this.props

    return (
      <div className={bc}>
        <h3 className={`${bc}__title`}>{t('user:Invite Peers')}</h3>
        <span className={`${bc}__cross`} onClick={() => onRequestClose()}>
          &times;
        </span>

        <form className={`${bc}__body`} onSubmit={handleSubmit} noValidate>
          <FieldArray name="users" component={PeerInviteInputs} />
          <div className={`${bc}__buttons-wrapper`}>
            <Button
              primary
              xs
              className={`${bc}__button `}
              type="submit"
              submitting={submitting}
              disabled={submitting || this.usersNotEmpty(users) || invalid}
              onClick={() => onRequestClose()}
            >
              {t('Send invitations')}
            </Button>

            <Button xs type="button" className={`${bc}__button  ${bc}__button-cancel`} onClick={() => onRequestClose()}>
              {t('Cancel')}
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

PeerInviteForm.displayName = 'PeerInviteForm'

export default withTranslation()(PeerInviteForm)
